import { render } from "./EdoDocumentTitleEmptyState.vue?vue&type=template&id=5e82dfd2&scoped=true"
import script from "./EdoDocumentTitleEmptyState.vue?vue&type=script&lang=js"
export * from "./EdoDocumentTitleEmptyState.vue?vue&type=script&lang=js"

import "./EdoDocumentTitleEmptyState.vue?vue&type=style&index=0&id=5e82dfd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e82dfd2"]])

export default __exports__